import { Link } from "react-router-dom";
import "./Header.css";

type HeaderPropsType = {
  headerText?: string;
};

const Header: React.FC<HeaderPropsType> = ({ headerText }) => {

  return (
    <div>
      {/* 戻るは副の操作（白地に枠）。矢印は文字ではなく SVG で描く */}
      <Link to={`/`} state={{ isCaptureModeForced: true, isUploadOnly: false, isStartEditMode: false }} className="btn btn-secondary backLink">
        <svg width="8" height="12" viewBox="0 0 8 12" aria-hidden="true"><path d="M7 1L2 6l5 5" fill="none" stroke="currentColor" strokeWidth="2" /></svg>
        名刺のホーム画面に戻る
      </Link>
    </div>

  );
}

export default Header;
